import Await from "../../components/async/Await";
import NavigatorView from "../../navigation/NavigatorView";
import RouteSwitch from "../../navigation/RouteSwitch";
import RouteView from "../../navigation/RouteView";
import MailingPage from "./MailingPage";
import MailPage from "./MailPage";
import { mailingNavigator, mailingRoute, mailRoute, newMailRoute } from "./navigation";
import NewMailPage from "./NewMailPage";

export default function MailingNavigator() {
    return (
        <NavigatorView navigator={mailingNavigator}>
            <Await>
                <RouteSwitch>
                    <RouteView route={mailingRoute} component={MailingPage} />
                    <RouteView route={newMailRoute} component={NewMailPage} />
                    <RouteView route={mailRoute} component={MailPage} />
                </RouteSwitch>
            </Await>
        </NavigatorView>
    );
}
